import { Component } from '@angular/core';

@Component({
    selector: 'app-capability',
    templateUrl: './capability.component.html',
    styleUrls: ['./capability.component.scss'],
    standalone: false
})
export class CapabilityComponent {

}
